<template>
  <v-container>
    <v-row class="mb-5" justify="space-between">
      <v-col cols="6">
        <v-row class="px-3">
          <v-col
            v-if="isOpenRegisters"
            cols="1"
            class="d-flex justify-center align-center"
          >
            <v-btn icon @click="closeRegister()">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="auto" class="d-flex justify-center align-center">
            <h5 v-if="!isOpenRegisters" class="text-subtitle-1 my-0">
              Campañas
            </h5>
            <h5 v-else class="text-subtitle-1 my-0">
              {{ campaignTitle }} | Por marcar ({{ notDialedCount }})
            </h5>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="auto">
        <v-text-field
          filled
          rounded
          dense
          v-model="searchQuery"
          @click="openSearchDialog"
          v-if="isOpenRegisters"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
          readonly
        ></v-text-field>
      </v-col>
    </v-row>
    <v-card class="shadow-1">
      <campaigns-table
        v-show="!isOpenRegisters && !isOpenRegistersQueue"
        @goToRegister="goToRegister"
      ></campaigns-table>
      <!-- Tabla -->
      <campaigns-register-queue
        v-if="isOpenRegistersQueue"
        :campaignId="campaignSelected"
        :clientId="clientId"
        :campaignType="campaignType"
        :isCustomSearch="isCustomSearch"
        :payloadSearch="payloadSearch"
      ></campaigns-register-queue>

      <campaigns-register
        v-else-if="isOpenRegisters"
        :campaignId="campaignSelected"
        :clientId="clientId"
        :campaignType="campaignType"
        :isCustomSearch="isCustomSearch"
        :payloadSearch="payloadSearch"
      ></campaigns-register>
    </v-card>
    <search-dialog
      :isOpenSearchDialog="isOpenSearchDialog"
      :isOpenRegisters="isOpenRegisters"
      @close:dialog="closeSearchDialog"
      @submit:search="submitSearch"
    ></search-dialog>
  </v-container>
</template>

<script>
// import vuescroll from "vuescroll";
import { PbxHttpClient } from "@/services/httpclient";
import CampaignsTable from "@/components/DialModule/CampaignsTable.vue";
// Secong level
import CampaignsRegisterQueue from "@/components/DialModule/CampaignsRegisterQueue.vue";
import CampaignsRegister from "@/components/DialModule/CampaignsRegister.vue";
import SearchDialog from "@/components/DialModule/SearchDialog.vue";
export default {
  components: {
    // vuescroll,
    CampaignsTable,
    CampaignsRegisterQueue,
    CampaignsRegister,
    SearchDialog
  },
  data() {
    return {
      isOpenRegistersQueue: false,
      isOpenRegisters: false,
      isOpenSearchDialog: false,
      isCustomSearch: false,
      payloadSearch: {},
      searchQuery: null,
      campaignSelected: null,
      notDialedCount: null,
      campaignTitle: null,
      clientId: null,
      campaignType: null
    };
  },
  methods: {
    goToRegister({
      id,
      name,
      client_id,
      assignment_agent,
      registers__not_dialed_count,
      registers__not_dialed_agent_count,
      type_campaign: { name: campaign }
    }) {
      this.isCustomSearch = false;
      this.searchQuery = null;
      this.campaignSelected = id;
      this.campaignTitle = name;

      if (assignment_agent == 1) {
        this.notDialedCount = registers__not_dialed_agent_count;
      } else {
        this.notDialedCount = registers__not_dialed_count;
      }

      this.clientId = client_id;
      this.campaignType = campaign;

      if (campaign === "Cola") {
        this.isOpenRegistersQueue = true;
      } else {
        this.isOpenRegisters = true;
      }
    },
    closeSearchDialog() {
      this.isOpenSearchDialog = false;
    },
    openSearchDialog() {
      this.isOpenSearchDialog = true;
    },
    async submitSearch(payload) {
      this.payloadSearch = payload;
      this.isCustomSearch = true;
      this.searchQuery = `${Object.keys(payload)[0]}:${
        Object.values(payload)[0]
      }`;
      this.closeSearchDialog();
    },
    async closeRegister() {
      try {
        await PbxHttpClient.get(
          `campaign/remove_register/${this.campaignSelected}`
        );
        this.isOpenRegisters = false;
        this.isOpenRegistersQueue = false;
      } catch (err) {
        // console.log("error calling now:", err);
        if (err.response)
          this.$snotify.error(err.response?.data?.error, "¡Error!");
        else
          this.$snotify.error("Hubo un error, intente mas tarde.", "¡Error!");
      }
    }
  }
};
</script>

<style></style>
